const FeedbackService = {

  addCopyToClipboardNotification(event) {
    /* eslint-disable no-underscore-dangle */
    if (window._copyClipboardTimer) {
      clearTimeout(window._copyClipboardTimer);
    }

    const targetElement = event.target;
    targetElement.classList.add('relative');

    const copiedElement = document.createElement('span');
    copiedElement
      .classList
      .add('absolute', 'top-0', 'text-xs', 'capitalize', 'text-pink-500', 'bold', 'slide-up-fade-in');

    copiedElement.textContent = 'Kopiert!';

    targetElement.insertBefore(copiedElement, null);

    window._copyClipboardTimer = setTimeout(() => {
      targetElement.removeChild(copiedElement);
      targetElement.classList.remove('relative');
    }, 250);
  },

};

export default FeedbackService;
